import React from 'react'
import {Box, Flex, Text, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {errorMessageStyle} from '../../../../components/product-item/index.style'
import {useGlobalError} from '../../util/global-error-context'

const GlobalErrorMessage = () => {
    const {hasGlobalError} = useGlobalError()
    if (!hasGlobalError) return null
    return (
        <Box mb={4}>
            <Flex
                sx={{
                    backgroundColor: 'whiteRed.10',
                    borderRadius: '5px',
                    px: {base: '10px', md: '12px'},
                    py: {base: '5px', md: '12px'},
                    mx: {base: '11px', md: 0},
                    my: {base: '-15px', md: 0},
                    mb: {base: '15px', md: '25px'}
                }}
                flexDirection="row"
                align="flex-start"
                gap="5px"
            >
                <Image
                    src={getAssetUrl('static/img/header/error-symbol.svg')}
                    alt="Error symbol"
                    sx={{w: '13px', h: '13px', mt: '2px'}}
                />
                <Text
                    sx={{
                        ...errorMessageStyle,
                        m: 0
                    }}
                >
                    <FormattedMessage
                        defaultMessage="Your shopping cart can currently not be ordered since one or more of the products in your cart have an invalid price or are not available in the requested quantity. If you have any questions, please contact Customer Service."
                        id="cart_error.global"
                    />
                </Text>
            </Flex>
        </Box>
    )
}

export default GlobalErrorMessage
